import React, { Component } from 'react';
import { connect } from 'react-redux';
import { modalActions, expenseEventActions, addAccountActions, accountActions, eventActions } from '../../../redux/root-action';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { Input, Dropdown, Button, CollapsibleHedge } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import ReactModalFooter from '../../Modal/ReactModalFooter';
import ReactModalHeader from '../../Modal/ReactModalHeader';
import ReactModalContent from '../../Modal/ReactModalContent';
import { eventModalViews, analyticsTracking, defaultOption, modals, postActions } from '../../../utils/constants';
import { getIntegerAmount, isNumeric, keyDown, formatAmountWithoutDollarAndDecimals } from '../../../utils/helpers';
import { FindValueOperator } from 'rxjs/internal/operators/find';

const StyledIntroText = styled.div`
    margin: 22px 0 26px;
    font-family: Nimbus Sans Light;
    font-size: 20px;
    font-weight: 300;
    line-height: 26px;
    letter-spacing: -0.5px;
    color: ${tokens.ColorGrey900};
    @media only screen and (max-width: 767px) {
        font-size: 16px;
        margin-top: 24px;
    }
`;

const StyledBoldText = styled.div`
    font-family: Nimbus Sans Bold;
    font-size: 16px;
    font-weight: bold;
    line-height: 22px;
    color: ${tokens.ColorGrey900};
`;

const StyledFieldContainer = styled.div`
  display: flex;
  @media only screen and (max-width: 767px) {
    width: 100%;
    margin-top: 16px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  ul {
    max-height: 320px;
    @media only screen and (max-width: 767px) {
      max-height: 240px;
    }
  }
`;

const StyledInputLabel = styled.div`
  color: ${tokens.ColorGrey900};
  font-size: 16px;
  line-height: 22px;
  height: 56px;
  flex: 0 0 182px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  @media only screen and (max-width: 767px) {
    height: auto;
    flex: 0;
  }
`;

const StyledInputValue = styled.div`
  height: 56px;
  align-items: flex-start;
  flex-direction: column;
  justify-content: right;
  > div {
    width: 256px;
  }

  > input[type=checkbox] {
    height: 16px;
    width: 16px;
    border-radius: 4px;
  }
  > label {
    font-weight: normal;
    color: ${tokens.ColorGrey600};
    margin-left: 8px;

  }
  @media only screen and (max-width: 767px) {
    height: auto;
    width: 100%;
    > div {
      width: 100%;
    }
  }
`;

const StyledError = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 14px;
  line-height: 18px;
  display: block;
  white-space: pre-wrap;
  color: ${tokens.ColorFunctionalRed700};
  margin: 8px 0 16px;
`;

const AgeRangeContainer = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  justify-content: space-between;
  margin-top: 8px;
  padding-right: 100px;
`;

const TextContainer = styled.div`
  margin-top: 12px;
  color: ${tokens.ColorGrey900};
`;

const InputsContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: right;
  margin-top: 8px;
`;

const LabelContainer = styled.div`
  flex: 0 0 32px;
  margin: 8px -4px 0 0;
  display: inline;
  color: ${tokens.ColorGrey800};

  &#future-expense-age-start-label {
    margin: 4px 4px 0 0;
    font-family: Nimbus Sans Regular;
    font-size: 14px;
    line-height: 16px;
    text-align: left;
    color: ${tokens.ColorGrey600};
    @media only screen and (max-width: 767px) {
      flex: 0 0 min-content;
    }
  }
`;

const InputWithMessage = styled.div`
flex: 1;
  > div {
    > div {
      height: 36px;
    }
    input {
      width: 90px !important;
      padding: 0;
      margin: 0 0 0 16px !important;
      @media only screen and (max-width: 767px) {
        height: 40px;
      }
    }
  }
`;


const InputMessage = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 14px;
  line-height: 18px;
  color: ${tokens.ColorGrey600};
  text-align: center;
  margin-top: 8px;
`;

const LabelMessage = styled.div`
  font-family: 'Nimbus Sans Regular';
  font-size: 14px;
  line-height: 18px;
  font-style: italic;
  color: ${tokens.ColorGrey700};
  margin-top: 8px;
`;

const StyledExpensesFooterText = styled.div`
  font-family: Nimbus Sans Italic;
  font-size: 16px;
  line-height: 22px;
  color: ${tokens.ColorGrey600};
  margin-bottom: 12px;
  @media only screen and (max-width: 767px) {
    margin-top: 32px;
    margin-bottom: 32px;
  }
`;

const StyledDelete = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  button {
    cursor: pointer;
    padding-left: 0;
    > div {
      font-family: Nimbus Sans Bold;
    }
  }
  img {
    width: 24px;
    height: 24px;
  }
`;
class AddFutureExpense extends Component<any, any> {

  constructor(props: any) {
    super(props);
    this.state = {
      expenseTypeError: '',
      incomeName: '',
      incomeAmount: '',
      startAge: '',
      endAge: '',
      amountError: false,
      startAgeError: false,
      endAgeError: false,
      checkboxClickedExpense: false,
    };
  }
  componentDidMount = () => {
    const { fetchExpenseEvents, events: { selectedEvent }, riScenario: { retirementStartAge } } = this.props;
    fetchExpenseEvents();

    if (selectedEvent?.isNewEvent) {
      const startAgeInputBox = document.getElementById('future-expense-age-input-start-age') as HTMLInputElement;
      if (startAgeInputBox) {
        startAgeInputBox.value = retirementStartAge;
      }
    }
  
    // for expense edit
    if (selectedEvent?.name) {
      const startAgeInputBox = document.getElementById('future-expense-age-input-start-age') as HTMLInputElement;
      if (startAgeInputBox) {
        startAgeInputBox.value = selectedEvent.startNumber;
      }
    }
  };

  showDeleteFutureExpense = () => {
    const { showModal, setCurrentView } = this.props;
    // showModal(modals.EVENTS);
    showModal(eventModalViews.DELETE_FUTURE_EXPENSE);
  };

  handleExpenseOptionChanges = (option: any) => {
    const { updateSelectedIncomeEvent } = this.props;
    updateSelectedIncomeEvent({
      typeName: option.name,
    });
    this.setState({
      expenseTypeError: false,
    });
  }

  handleChange = (e: any) => {
    const value = e.target.value;
    const allowedChars = /^[a-zA-Z0-9\s'.,-]+$/;
    const { updateSelectedIncomeEvent } = this.props;
    if (value.match(allowedChars) || value === '') {
      this.setState({
        incomeName: e.target.value,
        expenseNameError: false,
      })
      updateSelectedIncomeEvent({
        [e.target.name]: value,
      });
    }
  };

  handleAmountChangeExpense = (e: any) => {
    const { updateSelectedIncomeEvent } = this.props;
    const value = e.target.value;
    const allowedChars = /^[0-9.,\b]+$/;
    if (value.match(allowedChars) || value === '') {
      this.setState({
        amountError: false,
        incomeAmount: getIntegerAmount(e.target.value)
      })
      updateSelectedIncomeEvent({
        [e.target.name]: getIntegerAmount(value),
      });
    }
  };


  handleStartAgeExpense = (e: any) => {
    const { updateSelectedIncomeEvent } = this.props;
    const value = e.target.value;
    const allowedChars = /^[0-9\b]+$/;
    if (value.match(allowedChars) || value === '') {
      this.setState({ startAge: e.targetValue });
      updateSelectedIncomeEvent({
        [e.target.name]: parseInt(value),
      });
    } else {
      const remainingVal = e.target.value.substring(0, e.target.value.length - 1);
      e.target.value = remainingVal;
    }
  };

  handleEndAgeExpense = (e: any) => {
    const { updateSelectedIncomeEvent } = this.props;
    const { checkboxClickedExpense } = this.state;
    const value = e.target.value;
    const allowedChars = /^[0-9\b]+$/;
    if (value.match(allowedChars) || value === '') {

      this.setState({ endAge: e.target.value });
      updateSelectedIncomeEvent({
        [e.target.name]: parseInt(value),
      });

    }
  };

  handleAccountHolderOptionChange = (option: any) => {
    const { updateSelectedIncomeEvent } = this.props;
    updateSelectedIncomeEvent({
      accountHolder: option.name,
    });
  };

  onCheckboxClickExpense = () => {
    const {
      updateSelectedIncomeEvent
    } = this.props;

    this.setState({ checkboxClickedExpense: this.state.checkboxClickedExpense ? false : true }, () => {
      updateSelectedIncomeEvent({ frequency: this.state.checkboxClickedExpense ? 'ONET' : 'ANL' });
    });
  };

  handleCancel = () => {
    const {
      hideModal,
      setCurrentView,
      showModal,
      events: {
        selectedEvent,
        tempScenario,
      },
      updateEventsData,
    } = this.props;

    if (selectedEvent.action === postActions.ADD && selectedEvent.bpId === (null || undefined)) {
      tempScenario?.events.splice(selectedEvent.eventIndex, 1);
    }
    updateEventsData({ events: tempScenario.events });
    setCurrentView(eventModalViews.FUTURE_INCOME_MODAL);
    hideModal();
    showModal(eventModalViews.FUTURE_INCOME_MODAL);
  };

  handleSave = () => {
    const {
      updateEventsData,
      showModal,
      updateSelectedIncomeEvent,
      setCurrentView,
      events,
      account,
      events: { selectedEvent },
      riScenario: { scenarioId, participantProfile, spouseProfile, retirementStartAge, retirementEndAge, spouseRetirementStartAge, spouseRetirementEndAge, birthDate },
      accHolder,
    } = this.props;
    const {
      incomeName,
      incomeAmount,
      expenseNameError,
      amountError,
      startAgeRange,
      endAgeRange,
      startAgeError,
      endAgeError,
      ageErrorMessage,
      checkboxClickedExpense,
    } = this.state;
    const tempEvents = [...events?.tempScenario?.events];
    const {
      name,
      id,
      amount,
      accountHolder,
      error = {},
      selectedEventType = defaultOption,
      expenseOption,
      isNewEvent,
      eventIndex,
      includeInScenario = true,
      startNumber,
      endNumber,
      typeName,
      unit = 'AGE',
      frequency = this.state.checkboxClickedExpense ? 'ONET' : 'ANL',
      categoryName = 'Expense',
    } = selectedEvent;

    let today = new Date();
    let dob = new Date(birthDate);
    let currentAge = today.getFullYear() - dob.getFullYear();

    tempEvents[eventIndex] = {
      ...selectedEvent,
      action: id ? 'UPDATE' : 'ADD',
      bpId: accountHolder === accHolder ? participantProfile?.bpId : spouseProfile?.bpId,
      scenarioId,
      name: name,
      balance: amount,
      accountHolder: accountHolder,
      typeName,
      age: currentAge,
      frequency,
      includeInScenario,
      endNumber: frequency === 'ONET' ? null : endNumber,
      startNumber: startNumber ? startNumber : retirementStartAge,
      unit,
      categoryName,
      sameAsRetirementAge: startNumber === retirementStartAge && endNumber === retirementEndAge ? 'Yes' : 'No',
    }

    const selectedExpenseType = document.getElementById('future-expense-type-dropdown-selected') as HTMLInputElement | null;
    const selectedExpenseTypeValue = selectedExpenseType?.innerHTML;
    const amountInput = document.getElementById('future-expense-annual-amount-input') as HTMLInputElement | null;
    const annualAmountValue: any = (amountInput?.value);
    const startAgeInput = document.getElementById('future-expense-age-input-start-age') as HTMLInputElement | null;
    const startAgeValue: number = Number(startAgeInput?.value);
    const endAgeInput = document.getElementById('future-expense-age-input-end-age') as HTMLInputElement | null;
    const endAgeValue: number = Number(endAgeInput?.value);

    let checkboxValue = false;
    if (checkboxClickedExpense ? true : false || selectedEvent.frequency === 'ONET') {
      checkboxValue = true;
    }

    this.setState({
      expenseNameError: false,
      amountError: false,
      startAgeError: false,
      endAgeError: false,
      ageErrorMessage: '',
    })
    if (selectedExpenseTypeValue === 'Select' || !typeName) {
      this.setState({ expenseTypeError: true });
    }
    else if (name === '' || !name) {
      this.setState({ expenseNameError: true });
    }
    else if (!(getIntegerAmount(annualAmountValue) > 0)) {
      this.setState({ amountError: true });
    }
    else if (accountHolder === accHolder && startAgeValue < getIntegerAmount(retirementStartAge)) {
      this.setState({
        startAgeError: true,
        ageErrorMessage: 'Start age must be ' + retirementStartAge + ' or older.\n'
      })
    }
    else if (startAgeValue < 18) {
      this.setState({
        startAgeError: true,
        ageErrorMessage: 'Start age must be 18 or older.\n'
      })
    }
    else if (startAgeValue > 85) {
      this.setState({
        startAgeError: true,
        ageErrorMessage: 'Start age must be 85 or younger.\n'
      })
    }
    else if (frequency !== 'ONET' && (startAgeValue > endAgeValue)) {
      this.setState({
        startAgeError: true,
        ageErrorMessage: 'Start Age must be before end age.\n'
      })
    }
    else if (startAgeValue < (getIntegerAmount(currentAge) + 1)) {
      this.setState({
        startAgeError: true,
        ageErrorMessage: 'Start Age must be at least one year greater than current age.\n'
      })
    }
    else if ((startAgeValue === endAgeValue)) {
      this.setState({
        startAgeError: true,
        ageErrorMessage: 'Age range must be one year or longer.\n'
      })
    }
    else if (frequency !== 'ONET' && endAgeValue > 114) {
      this.setState({
        endAgeError: true,
        ageErrorMessage: 'End age must be 114 or younger.\n'
      })
    }
    else if (accountHolder === accHolder && frequency !== 'ONET' && (endAgeValue > getIntegerAmount(retirementEndAge))) {
      this.setState({
        endAgeError: true,
        ageErrorMessage: 'End age must be ' + retirementEndAge + ' or younger.\n'
      })
    }
    else if (accountHolder === accHolder && !endAgeValue && frequency !== 'ONET') {
      this.setState({
        endAgeError: true,
        ageErrorMessage: 'End age must be ' + retirementEndAge + ' or younger.\n'
      })
    }
    else if (accountHolder !== accHolder && startAgeValue < getIntegerAmount(spouseRetirementStartAge)) {
      this.setState({
        startAgeError: true,
        ageErrorMessage: 'Start age must be ' + spouseRetirementStartAge + ' or older.\n'
      })
    }
    else if (accountHolder !== accHolder && frequency !== 'ONET' && (endAgeValue > getIntegerAmount(spouseRetirementEndAge))) {
      this.setState({
        endAgeError: true,
        ageErrorMessage: 'End age must be ' + spouseRetirementEndAge + ' or younger.\n'
      })
    }
    else if (accountHolder !== accHolder && !endAgeValue && frequency !== 'ONET') {
      this.setState({
        endAgeError: true,
        ageErrorMessage: 'End age must be ' + spouseRetirementEndAge + ' or younger.\n'
      })
    }
    else {
      updateEventsData({ events: tempEvents })
      showModal(eventModalViews.FUTURE_INCOME_MODAL);
    }
  };

  render(): JSX.Element {
    const mq = window.matchMedia('(max-width: 767px)');
    const {
      expenseEvents,
      // accountHolderOptions,
      events: { selectedEvent },
      account: { accountHolderOptions },
      accHolder,
    } = this.props;

    // For testing purpose - populate incomeType locally -mac
    const expenseEvents1 = [
      {'id': 1, 'name': 'Custom', 'value': 'custom'},
      {'id': 2, 'name': 'Financial Gift', 'value': 'financial-gift'},
      {'id': 3, 'name': 'Healthcare', 'value': 'healthcare'},
      {'id': 4, 'name': 'Home Renovations', 'value': 'home-renovations'},
      {'id': 5, 'name': 'Major Purchase', 'value': 'major-purchase'}
    ];

    const {
      checkboxClickedExpense,
      incomeAmount,
    } = this.state;

    const showGlobalError = false;

    const numberInputKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
      const eventCode = event.key.toLowerCase();
      if (!(event.key !== null
        && (eventCode.includes("digit")
          || eventCode.includes("arrow")
          || eventCode.includes("home")
          || eventCode.includes("end")
          || eventCode.includes("backspace")
          || (eventCode.includes("numpad") && eventCode.length === 7)))
      ) {
        event.preventDefault();
      }
    };

    const {
      name,
      balance,
      accountHolder,
      error = {},
      selectedEventType = defaultOption,
      typeName,
      isNewEvent,
      startNumber,
      endNumber,
      amount,
      frequency,
    } = selectedEvent;

    return (
      <React.Fragment>
        <ReactModalHeader
          modalTitle="Future Expense"
          showClose={true}
          handleCloseIconClick={this.handleCancel}
        />
        <ReactModalContent showGlobalError={showGlobalError}>
          <StyledIntroText tabIndex={0} id={'future-expense-event-intro-text'}>
            Once you add a retirement expense entry, it will be included in your  projections.
            Please review your information regularly to make sure it’s up to date.
          </StyledIntroText>
          <StyledBoldText id={'future-expense-event-bold-text'}>All fields are required.</StyledBoldText>
          <StyledFieldContainer>
            <StyledInputLabel id={'future-expense-type-label'}>Expense Type</StyledInputLabel>
            <Dropdown
              label={typeName ? typeName : "Select"}
              options={expenseEvents}
              onChange={(option: any) => this.handleExpenseOptionChanges(option)}
              selectedOption={selectedEventType.name}
              name="typeName"
              width={mq.matches ? '100%' : 266}
              id={'future-expense-type-dropdown'}
              errorMessage={this.state.expenseTypeError && 'Please select an Expense Type'}
            />
          </StyledFieldContainer>
          <StyledFieldContainer>
            <StyledInputLabel id={'future-expense-name-label'}>Expense Name</StyledInputLabel>
            <Input
              name="name"
              value={name ? name : ''}
              type="text"
              placeholder="Expense Name"
              onChange={this.handleChange}
              autoComplete="off"
              aria-label="expenseName"
              width={mq.matches ? '100%' : 268}
              errorMessage={this.state.expenseNameError && 'Expense Name cannot be blank'}
              id={'future-expense-name-input'}
            />
          </StyledFieldContainer>
          <StyledFieldContainer>
            <StyledInputLabel id={'future-expense-annual-amount-label'}>Annual Amount</StyledInputLabel>
            <Input
              name="amount"
              value={(incomeAmount || incomeAmount === 0) ? formatAmountWithoutDollarAndDecimals(incomeAmount) : amount ? formatAmountWithoutDollarAndDecimals(amount) : ''}
              placeholder="Amount"
              onChange={this.handleAmountChangeExpense}
              autoComplete="off"
              aria-label="amount"
              helperText={'After-tax annual amount owner expects to pay.'}
              width={mq.matches ? '100%' : 268}
              leadingCharacter="$"
              maxLength={11}
              id={'future-expense-annual-amount-input'}
              errorMessage={this.state.amountError && 'Annual amount must be greater than $0'}
            />
          </StyledFieldContainer>
          <>
            {accountHolderOptions.length === 1 ? (
              <StyledFieldContainer>
                <StyledInputLabel id={'future-income-annual-owner-label'}>Owner </StyledInputLabel>
                <StyledInputValue>
                  <Input
                    value={accountHolder ? accountHolder : accHolder}
                    name="accountHolder"
                    autoComplete="off"
                    aria-label="owner"
                    width={mq.matches ? '100%' : 268}
                    errorMessage={''}
                    className="blocked_data"
                    id={'future-income-annual-owner-input'}
                    readOnly
                    disabled
                  />
                </StyledInputValue>
              </StyledFieldContainer>
            ) : (
              <StyledFieldContainer>
                <StyledInputLabel id={'future-expense-annual-owner-label'}>Owner </StyledInputLabel>
                <StyledInputValue>
                  <Dropdown
                    label="Select"
                    options={accountHolderOptions}
                    onChange={(option: any) => this.handleAccountHolderOptionChange(option)}
                    selectedOption={
                      accountHolderOptions.find((option: any) => option.name === accountHolder) || defaultOption
                    }
                    name="accountHolderOption"
                    width={mq.matches ? '100%' : 268}
                    errorMessage={''}
                    className="blocked_data"
                    id={'future-expense-annual-owner-input'}
                  />
                </StyledInputValue>
              </StyledFieldContainer>
            )}
          </>
          <StyledFieldContainer>
            <StyledInputLabel>Owner's Age</StyledInputLabel>
            <AgeRangeContainer id={`future-expense-age-container`}>
              <LabelContainer id={`future-expense-age-start-label`}>{'Start Age'}</LabelContainer>
              <InputWithMessage id={`future-expense-start-age-input`}>
                <Input
                  name="startNumber"
                  placeholder={startNumber ? startNumber : 'Age'}
                  // value={startNumber ? startNumber : ''}
                  onInput={this.handleStartAgeExpense}
                  width={90}
                  maxLength={3}
                  hasError={this.state.startAgeError}
                  textAlign={'center'}
                  id={`future-expense-age-input-start-age`}
                />
              </InputWithMessage>
              <LabelContainer id={`future-expense-age-end-label`} style={{ paddingLeft: '20px' }}>
                {'to'}
              </LabelContainer>
              <InputWithMessage id={`future-expense-end-age-input`}>
                <Input
                  name="endNumber"
                  placeholder="Age"
                  // value={frequency === 'ONET' ? endNumber ? endNumber : '' : null}
                  value={endNumber ? frequency === 'ONET' ? '' : endNumber : ''}
                  onChange={this.handleEndAgeExpense}
                  width={90}
                  maxLength={3}
                  textAlign={'center'}
                  hasError={this.state.endAgeError}
                  style={{ marginRight: 0 }}
                  disabled={frequency === 'ONET'}
                  id={`future-expense-age-input-end-age`}
                />
              </InputWithMessage>              
            </AgeRangeContainer>
          </StyledFieldContainer>
          {(this.state.startAgeError || this.state.endAgeError) && <StyledError id={`future-expense-age-error`} style={{marginLeft: mq.matches ? 'auto' : '182px', marginTop: mq.matches ? '8px' : '0'}}>{this.state.ageErrorMessage}</StyledError>}
          <StyledFieldContainer>
            <StyledInputLabel></StyledInputLabel>
            <StyledInputValue>
              <input
                type="checkbox"
                name={'future-expense-one-time-event'}
                id={'future-expense-one-time-event'}
                checked={frequency === 'ONET'}
                onClick={this.onCheckboxClickExpense}
              />
              <label htmlFor="future-expense-one-time-event" id={'future-expense-one-time-event-label'}>One time event</label>
            </StyledInputValue>
          </StyledFieldContainer>
          <StyledExpensesFooterText id={`future-expense-footer-text`}>
            Future income and expense entries are for retirement years. If you set the entry start or end age outside of the owner’s retirement ages, we will only project the years within the retirement age range.
          </StyledExpensesFooterText>
        </ReactModalContent>
        <ReactModalFooter CTAButtonText="Save"
          CTAButtonId={analyticsTracking.RIXFutureExpenseModalActionSave}
          hideCancel={true}
          handleCTAClick={this.handleSave} >
          {!isNewEvent && (<StyledDelete>
            <Button
              type="textButton"
              title="Delete Expense"
              fitContainerWidth={mq.matches ? true : false}
              icon={tokens.AssetIconDeleteOutline}
              marginLeftPx={0}
              tabIndex={0}
              id={analyticsTracking.RIXFutureExpenseModalActionDelete}
              onClick={this.showDeleteFutureExpense}
            />
          </StyledDelete>)}
          {!mq.matches && (
          <Button
            type="textButton"
            title="Cancel"
            marginRightPx={16}
            onClick={this.handleCancel}
            tabIndex={0}
            onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.handleCancel)}
            id={analyticsTracking.RIXFutureExpenseModalActionCancel}
          />
          )}
        </ReactModalFooter>
      </React.Fragment>
    )
  }

}

const mapStateToProps = ({ expenseEvents, account, events, riScenario }: any) => ({
  expenseEvents: expenseEvents.data,
  events,
  account,
  riScenario,
  accHolder: riScenario?.participantProfile?.firstName + ' ' + riScenario?.participantProfile?.lastName,
});

export default connect(mapStateToProps, {
  showModal: modalActions.showModal,
  hideModal: modalActions.hideModal,
  fetchExpenseEvents: expenseEventActions.fetchExpenseEvents,
  setCurrentView: eventActions.setCurrentView,
  updateEventsData: eventActions.updateIncomeEventData,
  updateSelectedIncomeEvent: eventActions.updateSelectedIncomeEvent,
})(AddFutureExpense);